module.exports = __webpack_public_path__ + "img/kfzx.10810f43.jpg";